<template>
  <div>
    <v-card height="775px" style="position:relative;padding-bottom:50px">
      <v-toolbar
        color="grey darken-3"
        dark
        flat
      >
        <v-toolbar-title>AIKnow</v-toolbar-title>
        <template v-slot:extension>
          <v-tabs
            v-model="tab"
            align-with-title
            background-color="transparent"
            grow
          >
            <v-tabs-slider color="red"></v-tabs-slider>

            <v-tab>Statistics</v-tab>
            <v-tab>Chats</v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items
        v-model="tab"
      >
        <v-tab-item>
          <Statistics ref="active"/>
        </v-tab-item>
        <v-tab-item>
          <Chats ref="completed"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import Statistics from '../components/ai_know/Statistics.vue';
import Chats from '../components/ai_know/Chats.vue';

export default {
  components: {
    Statistics,
    Chats,
  },

  data() {
    return {
      tab: 0,
    };
  },
};
</script>

<style scoped>
</style>
